import React, { useContext, useState, useEffect } from "react";

//MUI
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";

//MUI Icons
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { Clip } from "./ObjectAnalysisImage";

//Custom
import imgService from "@/services/imgService";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { ThumbBasicInfo } from "./ObjectAnalysisThumbs";

export type ObjectAnalysisImageCropProps = {
  ordinal: number;
  selectedRecord: DCRecord | null;
  imagesBasicInfo: Array<DCRecord>;
  onImageInfoSelect: Function;
  selectedImage: DCRecord | null;
  cropClip: Clip | null;
  onCropSaved: (imageId: number) => void;
  isDisabled: boolean;
  hidden: boolean;
  isHeightLargerThanWidth: boolean;
}

const ObjectAnalysisImageCrop = (props: ObjectAnalysisImageCropProps) => {

  const snackbarContext = useContext(SnackbarContext);

  const [b64, setB64] = useState<string>('');
  const [imageOrdinal, setImageOrdinal] = useState<number | null>(null);

  const { ordinal, selectedRecord, imagesBasicInfo, onImageInfoSelect, selectedImage, cropClip, onCropSaved, isDisabled, hidden, isHeightLargerThanWidth } = props;

  const baseRecordId = selectedRecord ? selectedRecord.id as number : null;

  useEffect(() => {
    setImageOrdinal(null);
    setB64("")
    if (selectedRecord && baseRecordId) {
      loadCrop();
    }
  }, [baseRecordId]);

  useEffect(() => {
    if (selectedRecord && Array.isArray(imagesBasicInfo) && imagesBasicInfo.length > 0) {
      const firstImageObjektId = imagesBasicInfo[0].objektId as number;
      if (firstImageObjektId === selectedRecord.id) {
        const photoId = ordinal === 1 ? selectedRecord.foto_1 as number : ordinal === 2 ? selectedRecord.foto_2 as number : null;
        const imgInfo = imagesBasicInfo.find(x => (x.imageId as number) === photoId);
        if (imgInfo) {
          setImageOrdinal(prev => prev === null ? imgInfo.ordinal as number : prev);
        }
      }
    }
  }, [imagesBasicInfo])

  const loadCrop = () => {
    if (selectedRecord && baseRecordId && ordinal) {
      const photoId = ordinal === 1 ? selectedRecord.foto_1 as number : ordinal === 2 ? selectedRecord.foto_2 as number : null;
      const clipText = ordinal === 1 ? selectedRecord.foto_1_extent as string : ordinal === 2 ? selectedRecord.foto_2_extent as string : null;
      if (photoId && clipText) {
        const clip = clipText.split(',').map(x => parseInt(x, 10)) as Clip;
        imgService.getRecordCrop(baseRecordId, photoId, clip)
          .then((resp) => {
            if (resp.data.image) {
              setB64(resp.data.image);
            }
          })
      } else {
        setB64("");
        setImageOrdinal(null);
      }
    }
  }

  const setCrop = () => {
    if (baseRecordId && ordinal && selectedImage && cropClip) {

      imgService.setRecordCrop(baseRecordId, ordinal, { imageId: selectedImage.id, clip: cropClip })
        .then((resp) => {
          if (resp.success) {
            imgService.getObjImage('operations/objekti', baseRecordId, selectedImage.id as number, 200, cropClip)
              .then((resp) => {
                if (resp.success) {
                  setImageOrdinal(selectedImage.ordinal as number);
                  setB64(resp.data.image);
                  onCropSaved(selectedImage.id as number);
                }
              })
          }
        })
    }
  }

  const handleClickOrdinal = () => {
    const image = imagesBasicInfo.find(img => (img.ordinal as number) === imageOrdinal);
    if (image) {
      onImageInfoSelect(image.id as number, image)
    }
  }

  const handleSave = () => {
    setCrop();
  }

  const handleDelete = () => {

    if (baseRecordId && ordinal) {
      imgService.deleteRecordCrop(baseRecordId, ordinal)
        .then((resp) => {
          if (resp.success) {
            setB64("");
            setImageOrdinal(null);
          }
        })
    }

  }

  return (hidden ? <></> :
    (<Box sx={{
      width: isHeightLargerThanWidth ? '100%' : 'auto',
      height: isHeightLargerThanWidth ? 'auto' : '50%',
      aspectRatio: '1/1',
      borderStyle: "solid",
      borderColor: "primary.light",
      borderWidth: 2,
      margin: "auto",
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      {!b64 ?
        <Typography fontSize={40} color="#CCC">{ordinal}</Typography>
        : null}
      {cropClip ?
        <Fab
          color="primary"
          size="large"
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,255,0.3)",
            borderRadius: 0,
          }}
          disabled={isDisabled}
          onClick={handleSave}
        >
          <SaveIcon />
        </Fab> : null}
      {imageOrdinal ?
        <Fab color="primary" size="small" sx={{ position: "absolute", top: 5, right: 5 }} onClick={handleClickOrdinal}>{imageOrdinal}</Fab> : null}
      {b64 ?
        <img
          width={"100%"}
          height={"100%"}
          src={`data:image/jpg;base64, ${b64}`}
        /> : null}
      {b64 ?
        <Fab color="primary" size="small" sx={{ position: "absolute", bottom: 5, right: 5 }} disabled={isDisabled} onClick={handleDelete}>
          <DeleteIcon />
        </Fab> : null}

    </Box>)
  )
}

export default ObjectAnalysisImageCrop;
